import { DetailsWidget } from '@/components/DetailsWidget/DetailsWidget';
import { Box } from '@/components/Box/Box';
import WarningSecondaryIcon from '@/images/WarningSecondaryIcon.svg?react';
import { Typography } from '@/components/Typography/Typography';
import { COLORS } from '@/styles/colors';
import { EmailLink } from '@/components/EmailLink/EmailLink';
import { EmailLinkBox } from './styles';
import { useQuery } from '@tanstack/react-query';
import { getInternalOrganizationMasterAdmins } from '@/bundle/_OrgAdmin/pages/InboundWire/api/api';

const PAYMENT_MESSAGE =
  ' Your organization has now reached your monthly limit for wires under your current subscription plan. So you are not able to view wire info for this sending.';
const DEPOSIT_MESSAGE =
  'Your organization has now reached your monthly limit for wires under your current subscription plan. So you are not able to assign Depositor to this wire.';

type AdminPaymentsLimitReachedWidgetType = {
  limitType?: 'payment' | 'deposit';
};

export const AdminPaymentsLimitReachedWidget = ({ limitType = 'payment' }: AdminPaymentsLimitReachedWidgetType) => {
  const { data } = useQuery({
    queryKey: ['get_internal_active_master_admins'],
    queryFn() {
      return getInternalOrganizationMasterAdmins({ limit: 3 });
    },
  });

  const masterAdmins = data?.body?.results;

  return (
    <DetailsWidget hasHighlight>
      <Box display='flex' flexDirection='column' rowGap='20px'>
        <Box display='flex' flexDirection='column' alignItems='center' rowGap='24px'>
          <WarningSecondaryIcon />
          <Box display='flex' flexDirection='column' rowGap='8px'>
            <Typography variant='subTitle' color={COLORS.black} fontWeight='medium' textAlign='center'>
              Monthly limit is reached.
            </Typography>
            <Typography variant='bodySmall' color={COLORS.black} textAlign='center'>
              {limitType === 'payment' ? PAYMENT_MESSAGE : DEPOSIT_MESSAGE}
            </Typography>
            <Typography variant='bodySmall' color={COLORS.black} textAlign='center'>
              Please reach out to the Master Admin of your organization:
            </Typography>
          </Box>
        </Box>
        <Box display='flex' flexDirection='column' rowGap='8px'>
          {masterAdmins?.map((masterAdmin) => {
            return (
              <EmailLinkBox key={masterAdmin.id}>
                <EmailLink variant='big' email={masterAdmin.email} />
              </EmailLinkBox>
            );
          })}
        </Box>
      </Box>
    </DetailsWidget>
  );
};
